import { createApiAction } from 'src/api';
import moment from 'moment';
export const FETCH_LOGGED_IN_USER_START = 'user/fetch_logged_in_user_start';
export const FETCH_LOGGED_IN_USER_SUCCESS = 'user/fetch_logged_in_user_success';
export const FETCH_LOGGED_IN_USER_FAILURE = 'user/fetch_logged_in_user_failure';
export const FETCH_MIDS_START = 'user/fetch_mids_start';
export const FETCH_MIDS_SUCCESS = 'user/fetch_mids_success';
export const FETCH_MIDS_FAILURE = 'user/fetch_mids_failure';
export const IMPERSONATE_ACCOUNT = 'user/impersonate_account';
export const FETCH_LOGIN_HISTORY_START = 'user/fetch_login_history_start';
export const FETCH_LOGIN_HISTORY_SUCCESS = 'user/fetch_login_history_success';
export const FETCH_LOGIN_HISTORY_FAILURE = 'user/fetch_login_history_failure';

const processDate = (d, endOfDay = false) =>
  moment.utc(d).format(`YYYY-MM-DD${endOfDay ? ' 23:59:59' : ' 00:00:00'}`);

export const fetchLoggedInUser = () =>
  createApiAction(
    {
      path: '/api/v1/me/',
      method: 'GET',
    },
    [
      FETCH_LOGGED_IN_USER_START,
      FETCH_LOGGED_IN_USER_SUCCESS,
      FETCH_LOGGED_IN_USER_FAILURE,
    ]
  );

export const finishOnboarding = financialInstitutionId =>
  createApiAction(
    {
      path: '/api/v1/me/',
      method: 'PATCH',
      body: {
        user_has_finished_onboarding: true,
        user_financial_institution_id: financialInstitutionId,
      },
    },
    [
      FETCH_LOGGED_IN_USER_START,
      FETCH_LOGGED_IN_USER_SUCCESS,
      FETCH_LOGGED_IN_USER_FAILURE,
    ]
  );

export const impersonateAccount = account => ({
  type: IMPERSONATE_ACCOUNT,
  payload: account,
});

export const fetchMerchantIds = ({ financialInstitutionId, accountId }) =>
  createApiAction(
    {
      path: `/api/v1/transactions/reporting_mids/${financialInstitutionId}/${
        accountId ? `${accountId}/` : ''
      }`,
    },
    [FETCH_MIDS_START, FETCH_MIDS_SUCCESS, FETCH_MIDS_FAILURE]
  );

export const fetchLoginHistory = ({ financialInstitutionId, start, end }) =>
  createApiAction(
    {
      path: `/api/v1/login-history/${
        financialInstitutionId ? `${financialInstitutionId}/` : ''
      }`,
      method: 'POST',
      body: {
        startdate: processDate(start),
        enddate: processDate(end, true),
      }
    },
    [
      FETCH_LOGIN_HISTORY_START,
      FETCH_LOGIN_HISTORY_SUCCESS,
      FETCH_LOGIN_HISTORY_FAILURE,
    ]
  );
